export default () => ({
  restrict: 'E',
  template: `<img ng-src="${window.location.pathname}{{img}}">`,
  scope: { img: '=image' },
});
